import { render } from "./TapBar.vue?vue&type=template&id=4d9f3818&scoped=true"
import script from "./TapBar.vue?vue&type=script&lang=js"
export * from "./TapBar.vue?vue&type=script&lang=js"

import "./TapBar.vue?vue&type=style&index=0&id=4d9f3818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9f3818"]])

export default __exports__